<template>
  <input
    ref="input"
    v-bind="$attrs"
    :value="texto"
    type="text"
    :inputmode="decimais > 0 ? 'decimal' : 'numeric'"
    :aria-invalid="invalido ? 'true' : null"
    :class="{ 'is-invalid': invalido }"
    :title="invalido ? entradaEstrita ? 'Respeite os limites e até ' + decimais + ' casas decimais. Use apenas vírgula ou ponto, sem separadores de milhar.' : 'Use somente números e uma vírgula ou um ponto decimal, sem separadores de milhar.' : $attrs.title"
    @focus="focar"
    @input="digitar"
    @blur="desfocar"
  >
</template>

<script>
import { decimalEdit, decimalNumber } from '@/utils/decimalInput'
const vazio = valor => valor === null || valor === undefined || valor === ''

export default {
  name: 'CampoNumerico',
  inheritAttrs: false,
  props: {
    value: { type: [Number, String], default: null },
    decimais: { type: Number, default: 2 },
    casasFixas: Boolean,
    entradaEstrita: Boolean,
    minimo: { type: Number, default: null },
    maximo: { type: Number, default: null },
    permitirNegativo: Boolean,
    formatar: { type: Boolean, default: true }
  },
  data: () => ({ focado: false, textoDigitado: '', invalido: false, editou: false }),
  mounted() { this.syncInvalid() },
  updated() { this.syncInvalid() },
  computed: {
    texto() {
      if (this.focado) return this.textoDigitado
      if (vazio(this.value)) return ''
      const number = decimalNumber(this.value)
      if (!Number.isFinite(number)) return String(this.value)
      if (!this.formatar) return String(number).replace('.', ',')
      return number.toLocaleString('pt-BR', { minimumFractionDigits: this.casasFixas ? this.decimais : 0, maximumFractionDigits: this.decimais, useGrouping: false })
    }
  },
  methods: {
    syncInvalid() {
      if (this.invalido || this.$el.closest('[data-field-invalid="true"]') || this.$attrs['aria-invalid'] === 'true') this.$el.setAttribute('aria-invalid', 'true')
    },
    focus() { this.$refs.input?.focus() },
    textoEditavel(valor) { const number = decimalNumber(valor); return number == null || !Number.isFinite(number) ? '' : String(number).replace('.', ',') },
    focar(event) {
      this.focado = true
      this.editou = false
      this.textoDigitado = this.textoEditavel(this.value)
      this.$nextTick(() => event.target.select())
    },
    numero(texto) {
      if (!texto || texto === '-' || texto === ',') return null
      const valor = Number(texto.replace(',', '.'))
      return Number.isFinite(valor) ? valor : null
    },
    digitar(event) {
      const entry = decimalEdit(event.target.value, this.decimais, this.permitirNegativo)
      const exceedsPrecision = (String(event.target.value).trim().split(/[.,]/)[1] || '').length > this.decimais
      const exceedsBounds = entry?.number != null && ((this.minimo !== null && entry.number < this.minimo) || (this.maximo !== null && entry.number > this.maximo))
      if (!entry || (this.entradaEstrita && (exceedsPrecision || exceedsBounds))) { event.target.value = this.textoDigitado; this.invalido = true; return }
      this.editou = true; this.textoDigitado = entry.text; event.target.value = entry.text
      const numero = entry.number
      this.invalido = numero !== null && ((this.minimo !== null && numero < this.minimo) || (this.maximo !== null && numero > this.maximo))
      this.$emit('input', numero)
    },
    desfocar() {
      if (!this.editou) { this.invalido = false; this.focado = false; return }
      let numero = this.numero(this.textoDigitado)
      if (numero !== null && this.minimo !== null) numero = Math.max(this.minimo, numero)
      if (numero !== null && this.maximo !== null) numero = Math.min(this.maximo, numero)
      if (numero !== null) numero = Number(numero.toFixed(this.decimais))
      this.invalido = false
      this.focado = false
      this.$emit('input', numero)
      this.$emit('blur', numero)
    }
  }
}
</script>
